// Web orders often put a hospital room in Address 2 ("Room 217"). When the
// recipient is discharged and staff pick the new address, that room used to
// ride along onto the home address (TF20261008-011).

const ROOM_PATTERN = /\b(room|rm|bed|icu)\b/i;

// Places where a room in Address 2 is expected.
const ROOM_LOCATION_TYPES = ['hospital', 'hotel'];

export function looksLikeRoom(address2) {
  return ROOM_PATTERN.test(String(address2 || ''));
}

/** True when Address 2 holds a room but the delivery isn't to a hospital or hotel. */
export function strayRoomInAddress2(address2, locationType) {
  return !!locationType && !ROOM_LOCATION_TYPES.includes(locationType) && looksLikeRoom(address2);
}

const norm = (v) => String(v || '').trim().toLowerCase();

/**
 * Address 2 after staff pick a Google suggestion. Google's unit wins. Otherwise
 * a move to a different street or zip drops the old Address 2, and `cleared`
 * says what was dropped so the form can offer to keep it.
 */
export function address2AfterPick(previous, picked) {
  if (picked.unit) return { address2: picked.unit, cleared: null };
  const oldAddress2 = String(previous.address2 || '').trim();
  const moved = norm(previous.address1) !== norm(picked.address1) || norm(previous.zip) !== norm(picked.zip);
  if (!moved || !oldAddress2) return { address2: previous.address2 || '', cleared: null };
  return { address2: '', cleared: oldAddress2 };
}
